module.exports = __webpack_public_path__ + "static/img/btn_submit1.a52fe15f.png";